import React from 'react';
import { DoneFilledIcon, Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import { AVAILABLE_INLINE_STATUSES, NOTIFICATION_AVAILABLE_STATUSES } from "../../../../../../../../store/common/constants";
import { getCheckAddressStatus, getInfoBlockStatusTexts } from "../../../../../store/selectors";
import styles from "./styles.pcss";
import { toLowerCaseFirstChar } from "../../../../../store/utils";
var cx = classNames.bind(styles);
var _ConnectionNotification = function _ConnectionNotification(_ref) {
  var status = _ref.status,
    text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    "data-t-id": "components-ConnectionNotification"
  }, AVAILABLE_INLINE_STATUSES.includes(status) ? /*#__PURE__*/React.createElement("div", {
    className: cx('notification-bar')
  }, /*#__PURE__*/React.createElement(DoneFilledIcon, {
    fill: "#4f8217",
    size: "m"
  }), /*#__PURE__*/React.createElement(Text, {
    size: "size6-r"
  }, text[toLowerCaseFirstChar(status)], " ")) : /*#__PURE__*/React.createElement(Text, {
    className: cx('additionalInfo'),
    size: "size6-r",
    tagType: "div"
  }, text[toLowerCaseFirstChar(status)]));
};
var mapStateToProps = function mapStateToProps(state) {
  var status = getCheckAddressStatus(state);
  return {
    status: getCheckAddressStatus(state),
    text: getInfoBlockStatusTexts(state),
    shouldRender: !NOTIFICATION_AVAILABLE_STATUSES.includes(status)
  };
};
var connector = connect(mapStateToProps);
export var ConnectionNotification = compose(connector, withRenderFlag)(_ConnectionNotification);